import actions from '@/store/modules/budget-template/actions'
import getters from '@/store/modules/budget-template/getters'
import mutations from '@/store/modules/budget-template/mutations'
import state from '@/store/modules/budget-template/state'

export default {
    actions,
    getters,
    mutations,
    state
}